// components/AttributeBadge.tsx
import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

interface AttributeBadgeProps {
  icon?: ReactNode;
  label: ReactNode;
  className?: string;
}

export function AttributeBadge({ icon, label, className }: AttributeBadgeProps) {
  return (
    <span
      className={cn(
        'h-11',
        'px-2 py-2',
        'text-md',
        '@lg/gameCard:text-lg',
        '@lg/gameCard:px-3',
        '@lg/gameCard:py-2',
        'inline-flex items-center space-x-1 rounded-full bg-neutral-900  font-medium text-customPurple-100',
        className,
      )}
    >
      {icon && <span className="flex-shrink-0">{icon}</span>}
      <span>{label}</span>
    </span>
  );
}
